module.exports = __webpack_public_path__ + "static/img/kddt.0528a6f2.png";